/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_Import_TitleInputs */



/**
* | output |
* | --- |
* | "Import registrations (CSV)" |
*
* @param {Csv_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const csv_import_title = /** @type {((inputs?: Csv_Import_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_Import_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Import des inscriptions (CSV)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar inscripciones (CSV)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Importar inscrições (CSV)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa iscrizioni (CSV)")
	return /** @type {LocalizedString} */ ("Import registrations (CSV)")
});